import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import SelectInput from "../../widgets/SelectInput";
import getCategorieTag from "../../services/getCategorieTag";
import getTag from "../../services/getTag";
import updateTag from "../../services/updateTag";

export default class EditTag extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.section = this.props.section || props.location.pathname.substring(8);
    this.pageName = props.pageName || this.section;

    this.state = {
      tagId: null,
      tag: "",
      categoriaTag: null,
      categorieTagOptions: [],
      isLoading: false,
    };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentTag = cookies.get("currentTag", { path: "/" });

    const tags = await getTag(username, token);
    const tag = tags.find((m) => m.id == currentTag);

    const categorieTagOptions = await getCategorieTag(username, token);

    this.setState({
      tagId: tag.id,
      tag: tag.tag,
      categoriaTag: categorieTagOptions
        .map((item) => ({ value: item.id, label: item.nome }))
        .find((option) => option.value === tag.id_categoria),
      categorieTagOptions: categorieTagOptions.map((item) => ({
        value: item.id,
        label: item.nome,
      })),
    });
  }

  render() {
    return (
      <div>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle title={"Modifica tag"} />

          <TextInput
            name={"ID Tag (per API form esterni)"}
            value={this.state.tagId || ""}
            readOnly={true}
          />

          <TextInput
            name={"Tag"}
            value={this.state.tag}
            onChange={(text) => {
              this.setState({ tag: text });
            }}
          />

          <SelectInput
            value={this.state.categoriaTag}
            name="Categoria tag"
            hidable={false}
            options={this.state.categorieTagOptions}
            onChange={(option) => this.setState({ categoriaTag: option })}
          />

          <FixButton title={"Salva"} callback={this.save.bind(this)} />
        </LoadingOverlay>
      </div>
    );
  }

  async save() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentTag = cookies.get("currentTag", { path: "/" });

    if (!currentTag || !this.state.tag || !this.state.categoriaTag) {
      alert("Errore: assicurati che il tag e la categoria siano presenti.");
      return;
    }

    try {
      await updateTag(
        username,
        token,
        currentTag,
        this.state.tag,
        this.state.categoriaTag.value
      );

      alert("Aggiornato con successo!");
      window.location.href = "/#/app/tag";
    } catch (error) {
      console.error("Errore nella chiamata:", error);
      alert("Si è verificato un errore nella chiamata. Per favore riprova.");
    }
  }
}
